import React from 'react';

import { ShortIdsByProject } from '@neptune/shared/entity-domain';

export type AttributeSearchSpaceTraceContextValue = {
  getShortIdsByProject: (projectIdentifiers?: string[]) => ShortIdsByProject;
  record: (pairs: Array<[projectIdentifier: string, projectId: string, shortId: string]>) => void;
};

const EMPTY_SHORT_IDS_BY_PROJECT: ShortIdsByProject = new Map();

export const AttributeSearchSpaceTraceContext =
  React.createContext<AttributeSearchSpaceTraceContextValue>({
    getShortIdsByProject: () => EMPTY_SHORT_IDS_BY_PROJECT,
    record: () => undefined,
  });
